import { Key01 } from '@untitledui/icons';

import type { TeamApiKey } from '@/lib/api/teamApiKeys';
import { Button } from '@/lib/base/buttons/button';

interface ConnectedKondoKeyPanelProps {
  kondoApiKey: TeamApiKey;
  onRegenerateClick: () => void;
  isRegeneratePending: boolean;
  onDisconnectClick: () => void;
  isDisconnectPending: boolean;
}

export function ConnectedKondoKeyPanel({
  kondoApiKey,
  onRegenerateClick,
  isRegeneratePending,
  onDisconnectClick,
  isDisconnectPending,
}: ConnectedKondoKeyPanelProps) {
  return (
    <div className='bg-bg-secondary rounded-lg border border-border-secondary overflow-hidden'>
      <div className='flex items-center justify-between p-4'>
        <div className='flex items-center gap-3'>
          <div className='w-8 h-8 bg-[var(--color-brand-v2-primary)] rounded flex items-center justify-center'>
            <Key01 className='w-4 h-4 text-white' />
          </div>
          <div>
            <p className='font-medium text-primary'>{kondoApiKey.name}</p>
            <p className='text-xs text-tertiary'>
              {kondoApiKey.prefix}••••••••
            </p>
          </div>
        </div>
        <div className='flex items-center gap-2'>
          <Button
            color='secondary'
            size='sm'
            onClick={onRegenerateClick}
            isLoading={isRegeneratePending}
            isDisabled={isRegeneratePending || isDisconnectPending}
          >
            Regenerate key
          </Button>
          <Button
            color='secondary'
            size='sm'
            onClick={onDisconnectClick}
            isLoading={isDisconnectPending}
            isDisabled={isRegeneratePending || isDisconnectPending}
          >
            Disconnect
          </Button>
        </div>
      </div>
    </div>
  );
}
